import React from 'react';
import PropTypes from 'prop-types';
import { MemberContent } from './MemberContent/MemberContent';
import { NonMemberContent } from './NonMemberContent/NonMemberContent';

export const MembershipPage = (props) => {
  const { MembershipExists } = props;

  return (
    <div className="cart-content">
      <div className="container">
        {MembershipExists ? <MemberContent {...props} /> : <NonMemberContent {...props} />}
      </div>
    </div>
  );
};

MembershipPage.propTypes = {
  MembershipExists: PropTypes.bool,
  Membership: PropTypes.array,
};

export const MembershipPageSC = (props) => {
  const { sitecoreData } = props;
  return <MembershipPage {...sitecoreData} />;
};

MembershipPageSC.propTypes = {
  sitecoreData: PropTypes.object,
};
